import { render, staticRenderFns } from "./bizError__form.vue?vue&type=template&id=2d1f8dc6"
import script from "./bizError__form.vue?vue&type=script&lang=js"
export * from "./bizError__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports